export default __webpack_public_path__ + "static/media/plsm.5cb34d42.webp";